<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'Smart venues' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  @defer (when tournament.venues.length > 0) {
    <ion-list>
      @for (venue of tournament.venues; let i = $index; track i) {
        <ion-item>
          <ion-label>{{ venue.venueName }}</ion-label>
          <ion-button color="danger" (click)="removeVenue(venue._id, i)" fill="clear">
            <ion-icon slot="icon-only" name="trash"></ion-icon>
          </ion-button>
        </ion-item>
      }
    </ion-list>
  } @placeholder {
    <ion-card>
      <ion-card-content>
        {{ 'You don\'t have any smart venues. Please reach out to us via feedback@ionsport.com for smart venue to be assigned.' | translate }}
      </ion-card-content>
    </ion-card>
  }

  @if (venues$ | async; as venues) {
    <ion-item>
      <ion-select #select label="Venues" interface="popover" placeholder="{{ 'Select venue' | translate }}">
          @for (venue of venues; track $index) {
            <ion-select-option [value]="venue">{{ venue?.venueName }}</ion-select-option>
          }
      </ion-select>

      <ion-button (click)="addVenue()" expand="block" fill="clear" shape="round">
        {{'Add' | translate}}
      </ion-button>
    </ion-item>
  }

</ion-content>